import {
  Content,
} from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import {
  EntityListProvider,
  EntityKindPicker,
  EntityListPagination,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import React, { useMemo, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import CustomDropdownFilter from './CustomDropdownFilter';
import { CatalogTableColumnsFunc } from '@backstage/plugin-catalog';
import {CustomCatalogTable} from "../CustomCatalogTable";
import { getStyledColumns } from '../../utils/helpers';
import { setSavedUrl } from '../../redux/catalogTableSlice';
import { useAppDispatch } from '../../redux/hooks';
import { EIRDropdownFilterConfig } from './EIRDropdownFilterConfig';

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(1.5),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  filterButton: {
    textTransform: 'none',
    fontWeight: 700,
    border: '1px solid #cccccc',
  },
  layout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  filterPanel: {
    width: 280,
    flexShrink: 0,
    alignSelf: 'flex-start',
    maxHeight: 'calc(100vh - 120px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(1),
  },
  tablePanel: {
    flex: 1,
    minWidth: 0,
  },
}));

interface CustomCatalogPageProps {
  columns?: CatalogTableColumnsFunc;
  initialKind: string;
  intiallySelectedKind?: any;
  intiallyAllowedKind?: string[];
  pagination?: EntityListPagination;
  headerDisplayable?: boolean;
  title?: string;
  pageTitleOverride?: string;
  hasDetails?: boolean;
}

export const EIRTable = ({ columns, initialKind }: CustomCatalogPageProps) => {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Service Catalog';
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const [showFilters, setShowFilters] = useState(false);

  // Apply fixed width and text wrapping to columns
  const tableColumns = useMemo(() => {
    if (!columns) return undefined;
  
    return (ctx: any) => {
      const baseColumns = typeof columns === 'function' ? columns(ctx) : columns;
      return getStyledColumns(baseColumns);
    };
  }, [columns]);

  useEffect(() => {
    const pathname = window.location.pathname;
    const search = window.location.search;
    const fullUrl = `${pathname}${search}`;
    
    dispatch(setSavedUrl(fullUrl));
    // localStorage.setItem('savedURL', fullUrl);
  }, [dispatch]);

  return (
    <>
      <div style={{position: 'sticky', top: 0, zIndex: 1300, backgroundColor:'black', color: 'white', padding: '18px',borderLeft: '0.1px solid #535353', fontWeight:"700", fontSize:'30px'}}>{orgName}</div>
      <Content className={classes.content}>
        <EntityListProvider pagination={{ limit: 500 }}>
          <div style={{ pointerEvents: 'none', opacity: 0, position: 'absolute', height: 0, overflow: 'hidden' }}>
            <EntityKindPicker initialFilter={initialKind} allowedKinds={['API']}/>
          </div>
          <div className={classes.toolbar}>
            <Button
              className={classes.filterButton}
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(prev => !prev)}
            >
              {showFilters ? 'Hide Filters' : 'Filters'}
            </Button>
          </div>
          <div className={classes.layout}>
            <div
              className={classes.filterPanel}
              style={{ display: showFilters ? 'block' : 'none' }}
            >
              <CustomDropdownFilter
                filterConfig={EIRDropdownFilterConfig}
                page="eirTable"
              />
            </div>
            <div className={classes.tablePanel}>
              <CatalogContent
                columns={tableColumns}
                title={'Entitlement Compliance Matrix'}
              />
            </div>
          </div>
        </EntityListProvider>
      </Content>
    </>
  );
};

const CatalogContent = (props: CustomCatalogPageProps) => {
  const {entities} = useEntityList();
  const {columns, headerDisplayable, hasDetails} = props;

  // Memoize columns at a higher level to prevent re-creation in CustomCatalogTable
  const memoizedColumns = useMemo(() => columns, [columns]);

  return (
      <CustomCatalogTable
          columns={memoizedColumns}
          title={'Entitlement Compliance Matrix'}
          subtitle={`${entities?.[0]?.kind ?? 'API'}s: ${entities.length}`}
          headerDisplayable={headerDisplayable}
          hasDetails={hasDetails}
          showSearchBar={false}
          showActionsColumn={false}
          entities={entities}
          fitToScreen
          maxHeight={'2000px'}
      />
  );
};

export default EIRTable;
